"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("jquery-address");
const CategoryChooser_1 = require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
require("../../../TdWebtoolkitControls/controls/List/List");
const List_1 = require("../../../TdWebtoolkitControls/controls/List/List");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
const synerisMethods_1 = require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
const ModificationInfo_1 = require("../../../TdWebtoolkitControls/model/ModificationInfo");
require("./search.tmpl.less");
const $ = require("jquery");
const m = require("../SynView");
const fav = require("../../javascript/controls/Favorites/Favorites");
class SearchFavorite_V1 {
    constructor(catId, depends, searchInstance) {
        this.catId = catId;
        this.depends = depends;
        this.searchInstance = searchInstance;
    }
}
class search extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
        this.raiseBeforeExecuteMethod = true;
        this.m_getSearchResultsRunning = false;
        this.m_initialImmediateSearchPerformed = false;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_urlSearchConstraits = {};
        this.icon = "fa-search";
    }
    getParametersFromUrl() {
        const that = this;
        super.getParametersFromUrl();
        that.m_urlSearchConstraits = {};
        $.each($.address.parameterNames(), (idx, paramName) => {
            if (/\./.test(paramName) && $.address.parameter(paramName))
                that.m_urlSearchConstraits[paramName.toLowerCase()] = decodeURIComponent($.address.parameter(paramName));
        });
    }
    getSelectionContext() {
        if (!this.m_$list.synList("isInitialized"))
            return super.getSelectionContext();
        return {
            parentControl: true,
            normalParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            selectedIds: this.m_$list.synList("getSelectedIds")
        };
    }
    resizeControls() {
        const that = this;
        if (that.m_$preview && that.m_$preview.data("synPreview"))
            that.m_$preview.synPreview("resize");
    }
    renderContents() {
        const that = this;
        let selectedIds;
        const maxhits = parseInt(Utilities_1.synUtil.Configs.getValue("maxhits"), 10);
        that.m_maxHits = isNaN(maxhits) ? 1000 : maxhits;
        const defhits = parseInt(Utilities_1.synUtil.Configs.getValue("defhits"), 10);
        that.m_defHits = isNaN(defhits) ? 300 : defhits;
        if (that.m_defHits > that.m_maxHits)
            that.m_defHits = that.m_maxHits;
        let currentMaxHits = Cookies.get("maxResults_search");
        if (!currentMaxHits)
            currentMaxHits = that.m_defHits;
        if (that.m_$list)
            selectedIds = that.m_$list.synList("getSelectedIds");
        that.m_$preview = that.m_$container.find("#Preview");
        that.m_$categoryChooser = that.m_$container.find("#CategoryChooser");
        that.m_$searchButton = that.m_$container.find(".btnSearch")
            .off("click").on("click", (event) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            Utilities_1.synUtil.beginAjaxProgress(that.m_$searchButton);
            that.m_$preview.synPreview("clearView");
            event.preventDefault();
            yield that.m_$list.synList("refreshAsync");
            Utilities_1.synUtil.endAjaxProgress(that.m_$searchButton);
            if ("phone" === that.m_clientDeviceClass)
                $("div.viewButtons > button[data-id='docsPane']").trigger("click");
        }))
            .text(Utilities_1.synUtil.Strings.getValue("menuquicksexecutequery"));
        that.m_$favorites = that.m_$container.find(".searchFavorites");
        that.m_$favorites
            .off("favoriteSelected").on("favoriteSelected", function (evt, id, data) {
            const searchData = data.data;
            const applyToPropertyPage = (favInstance) => {
                // Hinweis: favInstance ist die Datenstruktur, so wie sie in den Favoriten vorliegt. Diese entspricht der "alten" JSON-Datenstruktur
                const oldInst = that.m_$propertyPage.synPropertyPage("getInstance", true);
                const newInst = oldInst.clone();
                for (const prop in favInstance) {
                    if (favInstance.hasOwnProperty(prop)) {
                        if (newInst.items[prop])
                            newInst.items[prop].value = favInstance[prop].value;
                    }
                }
                that.m_$propertyPage.synPropertyPage("changeInstance", newInst);
            };
            const selectedCategory = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory");
            that.m_$propertyPage.one("instanceChanged", (evt) => {
                applyToPropertyPage(searchData.searchInstance);
                evt.preventDefault();
            });
            if (selectedCategory.id !== searchData.catId || selectedCategory.depends !== searchData.depends)
                that.m_$categoryChooser.synCategoryChooser("setSelectedCategory", searchData.catId, searchData.depends, true);
            else
                that.m_$propertyPage.synPropertyPage("refresh");
        })
            .off("newFavoriteRequested").on("newFavoriteRequested", function (evt, data) {
            data.favorite = that.getDataForNewFavorites();
        })
            .synFavorites({ readOnly: !that.m_editableFavorites, viewName: that.m_viewName });
        that.m_$container.find(".btnReset")
            .off("click").on("click", function () {
            that.m_urlSearchConstraits = {};
            $.address.queryString("");
            that.m_$propertyPage.synPropertyPage("refresh");
            that.m_$favorites.synFavorites("clearSelection");
        });
        that.m_$list = $("#docs");
        that.m_$propertyPage = $("#PropertyPage");
        that.m_$maxHits = that.m_$container.find("#searchMaxHits");
        that.m_$actualHits = that.m_$container.find("#searchActualHits");
        that.m_$hitsLabel = that.m_$container.find("#searchHitsLabel");
        that.m_$maxHitsLabel = that.m_$container.find("#searchMaxHitsLabel");
        that.m_$maxHits.kendoNumericTextBox({
            format: "n0",
            min: 1,
            value: currentMaxHits,
            max: that.m_maxHits,
            change() {
                Cookies.set("maxResults_search", this.value());
            }
        });
        that.m_$hitsLabel.text(Utilities_1.synUtil.Strings.getValue("showhits"));
        that.m_$maxHitsLabel.text(Utilities_1.synUtil.Strings.getValue("maxhits"));
        that.m_$actualHits.text("0").attr("data-actualhits", "0");
        that.m_$categoryChooser
            .off("initSuccess").on("initSuccess", (evt) => {
            const typeIdParam = $.address.parameter("typeid");
            const initiallySelectedCatId = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory").id;
            const switchTypeId = function () {
                if (that.m_updateListLayoutRunning || that.m_getSearchResultsRunning)
                    setTimeout(switchTypeId, 50);
                else {
                    that.m_setNewTypeIdInitialized = true;
                    const typeIdParamInt = parseInt(typeIdParam, 10);
                    if (that.m_$categoryChooser.synCategoryChooser("hasCategory", typeIdParamInt)) {
                        const depends = "true" === $.address.parameter("depends");
                        if (typeIdParamInt !== initiallySelectedCatId)
                            that.m_$categoryChooser.synCategoryChooser("setSelectedCategory", typeIdParamInt, depends);
                        else
                            that.m_$categoryChooser.synCategoryChooser("setDepends", depends);
                    }
                }
            };
            if (typeIdParam)
                switchTypeId();
        })
            .off("categorySelected").on("categorySelected", (_evt, cat) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            that.updatePropertyPage(cat.id);
            yield that.updateListLayoutAsync(cat.id);
            that.updateSelectionContext();
        }))
            .off("categorySelectedManually").on("categorySelectedManually", function (event, cat) {
            that.m_$favorites.synFavorites("clearSelection");
        })
            .off("dependsChangedManually").on("dependsChangedManually", function (event, depends) {
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        })
            .synCategoryChooser({
            includeAbstractCategories: true,
            showIcons: true,
            showTreeButton: true,
            showDependsCheckbox: true,
            ignoreCreateRight: true,
            selectionCookieName: $.address.parameter("typeid") ? undefined : "search",
            usedIn: CategoryChooser_1.ChooserUsedInSearch,
            mode: 1,
        });
        that.m_$preview
            .on("propertyPageValuesChanged", () => {
            that.askSaveChanges(false, (saveResult) => {
                that.m_$preview.synPreview("getPropertyPage").synPropertyPage("deleteUnsavedChanges");
                if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                    that.m_$preview.synPreview("getPropertyPage").synPropertyPage("commitChanges", {
                        success(currentInstance, commitResult) {
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    that.m_$preview.synPreview("recreateAsync");
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                            that.m_saveInProgress = false;
                            that.disableUI(false);
                        },
                        cleanUp() {
                            that.m_saveInProgress = false;
                            Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                        },
                        updatePropertyPageAfterCommit: true
                    });
                }
                else if (saveResult === m.ViewSaveResult.Cancel) {
                    that.m_$preview.synPreview("getPropertyPage").synPropertyPage("refresh");
                    that.disableUI(false);
                }
            });
        })
            .on("propertyPageValuesReverted", () => {
            that.disableUI(false);
        })
            .synPreview({
            editable: true,
            propertyPageCheckForUnsavedChanges: true
        });
        that.m_$propertyPage
            .off("search").on("search", function () {
            if (that.m_UIDisabled !== true)
                that.m_$list.synList("refresh");
        })
            .off("valuesChangedManually").on("valuesChangedManually", (evt, changedFields, changedInstance) => {
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        })
            .off("valuesRevertedManually").on("valuesRevertedManually", () => {
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        })
            .off("instanceChanged").on("instanceChanged", (evt) => {
            const typeIdParam = $.address.parameter("typeid");
            const typeIdParamInt = Number(typeIdParam);
            if (!isNaN(typeIdParamInt)) {
                if (that.m_$categoryChooser.synCategoryChooser("hasCategory", typeIdParamInt)) {
                    that.m_$propertyPage.synPropertyPage("changeInstance", that.m_urlSearchConstraits);
                }
                else
                    Utilities_1.synUtil.Notifications.error(kendo.format(Utilities_1.synUtil.Strings.getValue("ERROR_50|1004"), typeIdParam));
            }
        })
            .off("endSetTemplate").on("endSetTemplate", () => {
            window.waitConditions.set("propertyPageReady.search");
        })
            .synPropertyPage({
            layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table"
        });
    }
    forceRefresh(modificationInfo) {
        const that = this;
        let fullRefresh = false;
        const selectedIds = this.m_$list.synList("getSelectedIds");
        if (!modificationInfo)
            fullRefresh = true;
        else {
            if (modificationInfo.fullRefreshNecessary)
                fullRefresh = true;
            else {
                if (modificationInfo.modifiedInstances) {
                    this.m_$list.synList("update", modificationInfo.modifiedInstances);
                    this.m_$preview.synPreview("update", modificationInfo.modifiedInstances);
                }
                else if (modificationInfo.deletions) {
                    if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Object) {
                        this.m_$list.synList("delete", modificationInfo.deletions.instances);
                        const newCount = this.m_$list.synList("getItemCount").toString();
                        that.m_$actualHits.text(newCount).attr("data-actualhits", newCount);
                        this.m_$preview.synPreview("delete", modificationInfo.deletions.instances);
                    }
                }
                else if (modificationInfo.new)
                    fullRefresh = true;
            }
        }
        if (fullRefresh)
            that.m_$list.synList("refresh");
    }
    getDataForNewFavorites() {
        const searchInst = {};
        const inst = this.m_$propertyPage.synPropertyPage("getInstance", true);
        for (const prop in inst.items) {
            if (inst.items.hasOwnProperty(prop) && inst.items[prop].value) {
                // inst muss in die Favoriten-Datenstruktur umgewandelt werden. Die entspricht der "alten" JSON-Datenstruktur
                const item = {
                    isFTField: inst.items[prop].isFTField,
                    name: inst.items[prop].name,
                    searchExpression: true,
                    type: inst.items[prop].type,
                    value: inst.items[prop].value
                };
                searchInst[prop] = $.extend(true, {}, item);
            }
        }
        const cat = this.m_$categoryChooser.synCategoryChooser("getSelectedCategory");
        return new fav.FavoriteData(1, new SearchFavorite_V1(cat.id, cat.depends, searchInst));
    }
    disableUI(disable = true) {
        const that = this;
        super.disableUI(disable);
        if (that.m_$preview && that.m_$preview.data("synPreview")) {
            if (disable)
                that.m_$preview.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
            else
                that.m_$preview.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
        }
        if (that.m_$list.synList("isInitialized"))
            that.m_$list.synList("lock", disable);
        if (that.m_$searchButton) {
            if (disable)
                that.m_$searchButton.attr("disabled", "disabled").addClass("k-state-disabled").attr("onclick", "return false;");
            else
                that.m_$searchButton.removeAttr("disabled").removeClass("k-state-disabled").removeAttr("onclick");
        }
    }
    callContinueCallback(useWholeSearchResult, continueObject) {
        const that = this;
        if (useWholeSearchResult) {
            const depends = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory").depends;
            const maxCount = that.m_$maxHits.data("kendoNumericTextBox").value();
            const instance = that.m_$propertyPage.synPropertyPage("getInstance", true);
            continueObject.context.ids = instance; // Hinweis: ids kann entweder string[] oder EINE Instance sein. Siehe dazu MethodManager.executeMethod
            continueObject.additionalData = {
                "srm.paramissearchfilter": "Y",
                "cgexplorer.childs": depends ? "Y" : "N",
                "maxresults": maxCount,
            };
        }
        continueObject.continueCallback();
    }
    createNewMenu() {
        const that = this;
        super.createNewMenu();
        that.CommandTriggerTarget.off("beforeExecuteMethod").on("beforeExecuteMethod", (event, continueObject) => {
            if (continueObject.dataItem.style & synerisMethods_1.methodStyles.SearchResult) {
                // SearchResult-Methods!
                if (that.CommandLayouts.SelectionContext.SelCount > 0) {
                    // In der Trefferliste ist etwas selektiert
                    let dialogText = Utilities_1.synUtil.Strings.getValue("srmask." + continueObject.dataItem.method);
                    if (dialogText === "")
                        dialogText = Utilities_1.synUtil.Strings.getValue("srmask", "Do you want to process the whole search result?");
                    Utilities_1.synUtil.choice({
                        allowCancel: true,
                        text: dialogText,
                        options: [
                            {
                                id: 1,
                                text: Utilities_1.synUtil.Strings.getValue("menuyes"),
                            }, {
                                id: 2,
                                text: Utilities_1.synUtil.Strings.getValue("menuno"),
                            }
                        ],
                    }).then((id) => {
                        if (id === 1)
                            that.callContinueCallback(true, continueObject);
                        else if (id === 2)
                            that.callContinueCallback(false, continueObject);
                    });
                }
                else
                    that.callContinueCallback(true, continueObject);
            }
            else
                that.callContinueCallback(false, continueObject);
        });
    }
    //#endregion Inherited from SynView
    //#region Helpers
    updatePropertyPage(catId) {
        const that = this;
        that.m_$searchButton.attr("disabled", "disabled");
        const options = {
            mode: Base_1.PropertyPageMode.Search,
            typeId: catId,
            cleanUp() {
                that.m_$searchButton.removeAttr("disabled");
            }
        };
        that.m_$propertyPage.synPropertyPage("setTemplate", options);
        that.m_$propertyPage[0].scrollTop = 0;
    }
    updateListLayoutAsync(catId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            that.m_updateListLayoutRunning = true;
            that.m_$actualHits.text("0").attr("data-actualhits", "0");
            if (that.m_$list.synList("isInitialized")) {
                that.m_$list.synList("destroy");
                that.m_$list.html("");
                that.m_$preview.synPreview("clearView");
            }
            const searchImmediately = "true" === $.address.parameter("searchImmediately")
                && (that.m_setNewTypeIdInitialized || $.address.parameter("typeid") == undefined);
            yield that.m_$list
                .off("selectionChanged").on("selectionChanged", (_evt, ids) => {
                if (that.m_$preview && that.m_$preview.data("synPreview")) {
                    if (ids.length === 1)
                        that.m_$preview.synPreview("setInstanceAsync", ids[0], true);
                    else
                        that.m_$preview.synPreview("clearView");
                }
                that.updateSelectionContext();
            })
                .off("beforeSelectionChanged").on("beforeSelectionChanged", function (_e, continueObject) {
                if (that.m_UIDisabled)
                    continueObject.continueCallback(false);
                else
                    continueObject.continueCallback(true);
            })
                .off("fetchedIds").on("fetchedIds", function (evt, ids) {
                window.waitData.set("searchResultsReturned.search", ids);
            })
                .css("height", "100%")
                .synList({
                dataItemGenerator: (ctx) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    that.m_getSearchResultsRunning = true;
                    try {
                        const items = yield that.getSearchResultsAsync(ctx);
                        return items;
                    }
                    finally {
                        that.m_getSearchResultsRunning = false;
                    }
                }),
                autoBind: searchImmediately && !that.m_initialImmediateSearchPerformed,
                columnOptions: {
                    layoutName: "cceparalistctrl_doctype",
                    catIdDependent: true,
                    catId
                },
                raiseBeforeSelectionChanged: true
            });
            that.m_updateListLayoutRunning = false;
            if (searchImmediately)
                that.m_initialImmediateSearchPerformed = true;
        });
    }
    getSearchResultsAsync(ctx) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            that.m_getSearchResultsRunning = true;
            const depends = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory").depends;
            const maxCount = that.m_$maxHits.data("kendoNumericTextBox").value();
            const instance = that.m_$propertyPage.synPropertyPage("getInstance", true);
            if (depends)
                yield instance.addSearchField("cgexplorer.childs", "Y");
            return new Promise((resolve) => {
                Utilities_1.synUtil.beginAjaxProgress(that.m_$searchButton);
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("Search"),
                    requestData: { query: JSON.stringify(instance.toJSON()), maxResults: maxCount },
                    done(resultsId, _textStatus, _jqXHR, handlerKey) {
                        Utilities_1.synUtil.beginAjaxProgress(that.m_$searchButton);
                        let headers = {};
                        if (handlerKey)
                            headers["X-WS-Affinity"] = handlerKey;
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                            headers,
                            requestData: {
                                fieldNames: JSON.stringify(ctx.columnNames)
                            },
                            done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let actHits = data.total ? data.total.toString() : "0";
                                that.m_$actualHits.text(actHits).attr("data-actualhits", actHits);
                                if (data.moreRowsAvailable) {
                                    const fmt = Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("qrymoreresultsavailable2"));
                                    Utilities_1.synUtil.Notifications.info(kendo.format(fmt, that.m_maxHits));
                                }
                                that.resizeControls();
                                if (data.data.length === 0)
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("searchnoresults"));
                                const instances = yield Instance_1.Instance.fromJSONArray(data.data);
                                resolve(List_1.instancesToListDataItems(instances));
                                window.waitConditions.set("listReady.search");
                            }),
                            cleanUp: () => {
                                Utilities_1.synUtil.endAjaxProgress(that.m_$searchButton);
                            }
                        });
                    },
                    cleanUp: () => {
                        Utilities_1.synUtil.endAjaxProgress(that.m_$searchButton);
                    }
                });
            });
        });
    }
}
exports.search = search;
